module.exports = __webpack_public_path__ + "img/edistribuzione.f5fa63c4.svg";